import { obtenerUsuarioActual } from '@/lib/cliente';
import { Navigate } from 'react-router-dom';

/**
 * Componente que se monta en `/` y redirige según el rol del usuario:
 *   - rol 'admin' → /admin/obras
 *   - rol 'campo' (o cualquier otro) → /campo/avance
 *
 * Si no hay sesión, RequiereAuth ya habrá redirigido a /login antes.
 */
export function RedirigirPorRol() {
  const u = obtenerUsuarioActual();
  const esGestion = u?.rol === 'admin' || u?.rol === 'supervisor';
  const destino = esGestion ? '/admin/obras' : '/campo/avance';
  return <Navigate to={destino} replace />;
}
